import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import './styles/main.css';
import { installEffects } from './effects';
import { installErrorCapture } from './utils/error-capture';

const app = createApp(App);

app.use(createPinia());
app.use(router);
installErrorCapture(app, router);

app.mount('#app');
installEffects();
